export default __webpack_public_path__ + "static/media/ledger_fields_import_template.5a848a11.csv";